/**
 * Entrada. El teclado numerico en pantalla existe siempre: doce teclas son toda
 * la superficie de entrada que el juego necesita, asi que en movil no hay que
 * pelear con el teclado del sistema.
 */

export interface Handlers {
  digit: (d: string) => void;
  clear: () => void;
  freeze: () => void;
}

export function bindKeyboard(h: Handlers): void {
  addEventListener("keydown", (e) => {
    if (e.key >= "0" && e.key <= "9") {
      e.preventDefault();
      h.digit(e.key);
    } else if (e.key === "Backspace" || e.key === "Escape") {
      e.preventDefault();
      h.clear();
    } else if (e.code === "Space") {
      e.preventDefault();
      h.freeze();
    }
  });
}

export function buildKeypad(root: HTMLElement, h: Handlers): HTMLButtonElement {
  for (const d of ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"]) {
    const b = document.createElement("button");
    b.textContent = d;
    b.setAttribute("aria-label", `Digito ${d}`);
    b.addEventListener("pointerdown", (ev) => {
      ev.preventDefault();
      h.digit(d);
    });
    root.appendChild(b);
  }

  const clear = document.createElement("button");
  clear.className = "util";
  clear.textContent = "Borrar";
  clear.addEventListener("pointerdown", (ev) => {
    ev.preventDefault();
    h.clear();
  });
  root.appendChild(clear);

  const freeze = document.createElement("button");
  freeze.className = "pw";
  freeze.id = "pw-btn";
  freeze.textContent = "Congelar";
  freeze.addEventListener("pointerdown", (ev) => {
    ev.preventDefault();
    h.freeze();
  });
  root.appendChild(freeze);

  return freeze;
}
